import { render } from "./LearningUnit.vue?vue&type=template&id=e1f44a9a&scoped=true"
import script from "./LearningUnit.vue?vue&type=script&lang=js"
export * from "./LearningUnit.vue?vue&type=script&lang=js"

import "./LearningUnit.vue?vue&type=style&index=0&id=e1f44a9a&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\DGWA\\Documents\\tokyo-shoseki_R8_042024\\08k\\08k_sigb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f44a9a"]])

export default __exports__